import A1_CONSTANTS from '../../a1/core/_const'

export const getA1LabelFromStatus = (status: string): string => {
  return (
    Object.values(A1_CONSTANTS.OPTIONS_JOURNEY_STATUS).find((option) =>
      option.value.includes(status)
    )?.label || ''
  )
}
